<div class="subscriptions-container">
  <section class="subscriptions-main-card">
    <div class="button-back-container">
      <ion-col size="3">
        <app-back-button (clicked)="goBack()" [text]="'Volver'">
        </app-back-button>
      </ion-col>
    </div>
    <div class="detail-title">
      <ion-label class="apv-title font-weight-700"
        >Tus suscripciones APV</ion-label
      >
    </div>
    <ion-card *ngIf="loaded" class="ion-card">
      <ion-card-header class="apv-detail-text"> Tu saldo: </ion-card-header>
      <ion-row class="row-from-content">
        <ion-card-content class="apv-balance-text">{{
          selectedAccount.amount | currency: "CLP":"symbol-narrow"
        }}</ion-card-content>
        <ion-card-content class="subscription-text"
          >Tienes 1 suscripción</ion-card-content
        >
      </ion-row>
      <div class="apv-fund-info">
        <span class="apv-fund-info__label">Fondo :</span>
        <span *ngIf="multiFund as fund; else generationalFund" class="apv-fund-info__name"
          >{{ fund.id }} - {{ fund.risk }}</span
        >
        <ng-template #generationalFund>
          <span class="apv-fund-info__name">{{
            fundDisplayName ||
              selectedAccount.funds?.[0]?.id + " " + fundSelectedPercentage + "%"
          }}</span>
        </ng-template>
      </div>
    </ion-card>
    <!-- skeleton screen-->
    <ion-card *ngIf="!loaded" class="ion-card">
      <ion-card-header class="apv-detail-text"> Tu saldo: </ion-card-header>
      <ion-row class="row-from-content">
        <ion-card-content class="apv-balance-text">
          <ion-skeleton-text
            animated
            class="width: 70%; height: 20px"
          ></ion-skeleton-text
        ></ion-card-content>

        <ion-card-content class="subscription-text"
          ><ion-skeleton-text
            animated
            class="width: 70%; height: 20px"
          ></ion-skeleton-text
        ></ion-card-content>
      </ion-row>
    </ion-card>
  </section>

  <!-- subscriptions details ok-->
  <section class="subscriptions-list-container" *ngIf="subscriptionsDataLoaded">
    <div *ngFor="let sub of subscriptions; let index = index">
      <subscription-card
        [subscriptionData]="sub"
        [subscriptionIndex]="index"
      ></subscription-card>
    </div>
  </section>

  <!-- subscriptions details error-->
  <section class="subscriptions-list-container" *ngIf="subscriptionsDataFailed">
    <div>
      <p>Ups! Error al obtener suscripciones vigentes.</p>
    </div>
  </section>

  <!--subscriptions skeleton-->
  <section
    class="subscription-skeleton-container"
    *ngIf="showSubscriptionsSkeleton"
  >
    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col size="12">
          <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
        </ion-col>
      </ion-row>
      <ion-row class="ion-justify-content-center">
        <ion-col size="12">
          <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
        </ion-col>
      </ion-row>
      <ion-row class="ion-justify-content-center">
        <ion-col size="12">
          <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
        </ion-col>
      </ion-row>
    </ion-grid>
  </section>
</div>
